import axios from "@/plugins/axios";

let url = "/api/console/user/codes";

/** @typedef {object} UserCode */

export const codes = {
    /**
     * @param {import("axios").AxiosRequestConfig} data
     * @returns {Promise<{ summary: { totalCount: number }, codes: UserCode[]}>}
     */
    gets(data) {
        return axios.get(url, data).then((result) => result.data);
    },

    /**
     * @param {{ _id: string }} data
     * @returns {Promise<{ code: UserCode }>}
     */
    get(data) {
        return axios.get(`${url}/${data._id}`).then((result) => result.data);
    },

    /**
     * @param {Partial<UserCode>} data
     * @returns {Promise<{ code: UserCode }>}
     */
    post(data) {
        return axios.post(url, data).then((result) => result.data);
    },

    /**
     * @param {Partial<UserCode>} data
     * @returns {Promise<{ code: UserCode }>}
     */
    put(data) {
        return axios.put(`${url}/${data._id}`, data).then((result) => result.data);
    },

    /**
     * @param {{ _id: string }} data
     * @returns {Promise<{ code: UserCode }>}
     */
    delete(data) {
        return axios.delete(`${url}/${data._id}`).then((result) => result.data);
    },
};

export default codes;
